import { render, staticRenderFns } from "./reviewrequest.vue?vue&type=template&id=bf6dfa04&scoped=true&"
import script from "./reviewrequest.vue?vue&type=script&lang=js&"
export * from "./reviewrequest.vue?vue&type=script&lang=js&"
import style0 from "./reviewrequest.vue?vue&type=style&index=0&id=bf6dfa04&lang=less&scoped=true&"
import style1 from "./reviewrequest.vue?vue&type=style&index=1&id=bf6dfa04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf6dfa04",
  null
  
)

export default component.exports